<template>
  <Card noBorder>
    <SectionHeader
      title="Password Configurations"
    >
      {{ $options.instructions }}
    </SectionHeader>
    <PasswordConfigurationGoogle
      v-if="gSuiteServers.length > 0"
      v-model="gSuiteServers"
    />
    <PasswordConfigurationMicrosoft
      v-if="o365Servers.length > 0"
      v-model="o365Servers"
    />
    <PasswordConfigurationLdap
      v-if="!!ldapServer.id"
      v-model="ldapServer"
    />
    <PasswordConfigurationRadius
      v-if="radiusServers.length > 0"
      v-model="radiusServers"
    />
  </Card>
</template>

<script>
import { Card } from '@jumpcloud/ui-components';
import PasswordConfigurationGoogle from 'client/settings/Security/PasswordConfigurationGoogle.vue';
import PasswordConfigurationLdap from 'client/settings/Security/PasswordConfigurationLdap.vue';
import PasswordConfigurationMicrosoft from 'client/settings/Security/PasswordConfigurationMicrosoft.vue';
import PasswordConfigurationRadius from 'client/settings/Security/PasswordConfigurationRadius.vue';
import SectionHeader from 'client/settings/components/SectionHeader.vue';
import createComputedObjectBinding from 'client/util/createComputedObjectBinding';

const instructions = "Settings that control what happens to a user's connected resource accounts when they are locked out or their password expires.";

export default {
  name: 'SectionPasswordConfiguration',

  components: {
    Card,
    PasswordConfigurationGoogle,
    PasswordConfigurationLdap,
    PasswordConfigurationMicrosoft,
    PasswordConfigurationRadius,
    SectionHeader,
  },

  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    gSuiteServers: {
      ...createComputedObjectBinding('gSuiteServers'),
    },

    ldapServer: {
      ...createComputedObjectBinding('ldapServer'),
    },

    o365Servers: {
      ...createComputedObjectBinding('o365Servers'),
    },

    radiusServers: {
      ...createComputedObjectBinding('radiusServers'),
    },
  },

  instructions,
};
</script>
